module.exports = __webpack_public_path__ + "img/42.6.CODm.dbbe0fee.png";